module.exports = __webpack_public_path__ + "media/images/fm_2-531ebbd3bbeb04a237c7c42df72cbf70.png";